var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.941 4H5.05898C4.48419 4 4.03073 4.48484 4.14436 5.04829C4.2788 5.71488 4.53202 6.53689 5 7C5.43179 7.4273 5.89905 7.68289 6.24204 7.82858C6.52989 7.95085 6.75 8.22402 6.75 8.53675C6.75 8.81481 6.57593 9.06278 6.32196 9.176C5.92205 9.35428 5.33748 9.65274 5 10C4.54433 10.4689 4.29086 11.2822 4.1532 11.9438C4.03543 12.5098 4.4899 13 5.06806 13H10.9319C11.5101 13 11.9646 12.5098 11.8468 11.9438C11.7091 11.2822 11.4557 10.4689 11 10C10.6625 9.65274 10.078 9.35428 9.67804 9.176C9.42407 9.06278 9.25 8.81481 9.25 8.53675C9.25 8.22402 9.47011 7.95085 9.75796 7.82858C10.101 7.68289 10.5682 7.4273 11 7C11.468 6.53689 11.7212 5.71488 11.8556 5.04829C11.9693 4.48484 11.5158 4 10.941 4Z",
    stroke: "#002A69",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5172 12H5.48284C5.30466 12 5.21543 11.7846 5.34142 11.6586L6.5 10.5L7.85858 9.14142C7.93668 9.06332 8.06332 9.06332 8.14142 9.14142L9.5 10.5L10.6586 11.6586C10.7846 11.7846 10.6953 12 10.5172 12Z",
    fill: "#002A69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83945 6H6.16056C5.96267 6 5.88497 6.25664 6.04961 6.36641L6.34089 6.56059C6.77922 6.85282 7.18762 7.18762 7.56014 7.56014L7.85858 7.85858C7.93668 7.93668 8.06332 7.93668 8.14142 7.85858L8.43986 7.56014C8.81238 7.18762 9.22078 6.85282 9.65911 6.56059L9.95039 6.36641C10.115 6.25665 10.0373 6 9.83945 6Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/Request.04237faa792255dd33597cf7e9918cd6.svg";
export { ForwardRef as ReactComponent };